import { getGroupId } from "../base/conference";
import { PARTICIPANT_STATUS, ROLE } from "../base/participants";
import { GROUP_DEFAULT_NAME, HOST_NAME, NICKNAME, PARTICIPANT_ALL_COUNT, PARTICIPANT_BELONG_COUNT } from "./constants";


export function getStartGroup(state) {
    const { status } = state['features/group'];
    return status;
}

// 특정 그룹 정보 가져오기 
export function getFocusGroup(state, uuid = null) {
    let focusGroup = uuid;
    if (!focusGroup) focusGroup = state['features/group'].focusGroup; 
    const { list } = state['features/group'];
    return list.find(item => item.uuid === focusGroup);
}

export function getGroupList(state) {
    const { list } = state['features/group'];
    return list.filter(i => i.uuid !== GROUP_DEFAULT_NAME).sort((a, b) => {
        const valueOfKeyA = a.name.toUpperCase();
        const valueOfKeyB = b.name.toUpperCase();
        return valueOfKeyA.localeCompare(valueOfKeyB, undefined, {
            numeric: true,
            sensitivity: 'base',
        });
    });
}

// 그룹 이름 가져오기
export function getGroupName(state, uuid) {
    try {
        const group = getFocusGroup(state, uuid);

        return group.name;
    } catch (err) {
        return false;
    }    
}

// 그룹 닉네임, 그룹 권한, 그룹 아이디로 가져온 그룹 사용자들
export function getGroupParticipant(state, isHost = false) {
    const { group: groupParticipant, remote } = state['features/base/participants'];

    // 만약 그룹이 시작 중인 경우, 그룹의 기본값은 로비로 보낸다 
    let items = new Array();
    remote.forEach(m => {
        if (!isHost && m.role === ROLE.HOST) return;
        let particiapnt = groupParticipant && groupParticipant.get(m.user_uuid);        
        if (particiapnt && particiapnt.type === "hidden") return;
        const group_id = particiapnt ? particiapnt.group_id : "";

        items.push({ 
            user_id: m.user_uuid,
            nickname: m.nickname,
            role_name: particiapnt ? particiapnt.role_name : (isHost ? ROLE.HOST : ""), 
            status: m.status === PARTICIPANT_STATUS.OCCUPIDE ? true : false, 
            group_id
        });
    });

    return items;
}

// 특정 그룹 사용자 가져오기
export function getFocusGroupParticipant(state, uuid = null, isHost = false) {
    let focusGroup = uuid;
    if (!focusGroup) focusGroup = state['features/group'].focusGroup;

    const participant = getGroupParticipant(state, isHost);

    return participant.filter(item => item.group_id === uuid);
}

// 전체 그룹 상태 가져오기
export function getGroupStatus(state, uuid) {
    const all = getFocusGroupParticipant(state, uuid);
    const belong = all.filter(m => m.status === true);
    const host = getFocusGroupParticipant(state, uuid, true).find(p =>p.role_name === ROLE.HOST);

    return {
        [PARTICIPANT_BELONG_COUNT]: belong.length || 0, 
        [PARTICIPANT_ALL_COUNT]: all.length || 0,
        [HOST_NAME] : host ? host.nickname : "-"
    }
}

// 모든 그룹 상태 가져오기 
export function getAllGroupStatus(state) {
    // const { list } = state['features/group'];
    const list = getGroupList(state);    
    let data = new Array();
    list.map(g => {
        const groupState = getGroupStatus(state, g.uuid);

        data.push({ ...groupState, ...g, open_time: Date.parse(g.open_time) });
    });

    return data;
}

// 닉네임 가져오기
export async function getNicknameByUserID(user_id) {    
    const { complete, message } = await APP.API.getAllParticipant({ user_id });
    if (complete ) {
        return message.find(p => p.nickname !== "")?.nickname || ""
    }
}

// 내가 속한 그룹 가져오기
export function getGroupIdByUserID(state, user_id) {
    const { group: groupParticipant } = state['features/base/participants']; 
    return groupParticipant && groupParticipant.get(user_id);
}

// 
export function checkIsOpenedGroup(state, group_id) {
    // 그룹이 실행 중인 경우 
    const start = getStartGroup(state);
    if (start) {
        // 현재 사용자의 그룹 
        const currentGroupId = getGroupId(state);

        // 시작된 그룹 리스트만 가져오기 
        const startGroup = getStartGroupList(state);
        
        if (currentGroupId === "") {
            // 로비그룹인 경우 
            // 시작되지않은 회의 사용자도 표출
            if (startGroup.indexOf(group_id) === -1) return true;
        } else {
            // 그룹 인 경우 
            // 나와 같은 그룹이여야함
            if (currentGroupId === group_id) return true;
        }
        return false;        
    }

    return true;
}

export function getStartGroupList(state) {
    const startGroup = new Array();
    getGroupList(state).map(g => {
        if (g.status === "opened") startGroup.push(g.uuid);
    });

    return startGroup;
}